import { LanguageOptions } from '../data'

export const getLanguageById = (languageId: number) => {
  const languageName = LanguageOptions.find(
    (o) => o.judge_zero_id === languageId
  )

  if (languageName) return languageName.editorLang

  return 'N/A'
}

export const getLanguageName = (languageId: string) => {
  const languageName = LanguageOptions.find((o) => o.id === languageId)

  if (languageName) return languageName.editorLang

  return 'N/A'
}
